module.exports = __webpack_public_path__ + "img/land-location-alkhalil.7b441209.png";